<template>
    <div class="discount-box">
        <div class="radio-box">
            <div class="radio-line" v-for="(item, i) in allType" :key="i">
                <el-radio v-model="discount.discount_type" :label="item.value" @change="syncDiscountData">{{item.label}}</el-radio>
            </div>
        </div>
        <div class="set-box" v-show="discount.discount_type == 2">
            <el-form label-position="left" label-width="80px">
                <el-form-item :label="item.vip_name" v-for="(item, i) in discountData" class="set-line" :key="i">
                    <el-input v-model="item.vip_price" @change="syncDiscountData"></el-input>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
    import obj from "@/js/obj";
    export default {
        name: "DiscountRadio",
        model:{
            prop: "discount",
            event: "change"
        },
        props: {
            discount: {
                type: Object,
                default: () => ({
                    discount_type: "0",
                    discount_data: ""
                })
            }
        },
        data: () => ({
            allType: [
                {
                    label: "无折扣",
                    value: "0"
                }, {
                    label: "会员等级折扣",
                    value: "1"
                }, {
                    label: "会员固定价格",
                    value: "2"
                }
            ],
            discountData: [
                // {
                //     vip_id: 1,
                //     vip_name: "黄金VIP",
                //     vip_price: "80"
                // }
            ],
            vipData: []
        }),
        mounted: function(){
            this.initDiscount();
            this.loadVipData();
        },
        methods: {
            //加载vip数据
            loadVipData: function () {
                obj.postData("cash/store_user/get_store_vip", {}, function (res) {
                    if(res.errcode === 0)
                        this.vipData = res.data;
                    else if(res.errcode > 0)
                        obj.message.error(res.errdesc);
                }.bind(this));
            }

            //初始化discount数据
            ,initDiscount: function () {
                if(!obj.isEmpty(this.discount.discount_data)){
                    let disObj = JSON.parse(this.discount.discount_data);
                    if(obj.isEmpty(this.discountData))
                        this.discountData = disObj;
                    else{
                        let disData = [];
                        this.discountData.forEach((item) => {
                            let price = "";
                            for (let k in disObj){
                                if(disObj[k].vip_id == item.vip_id){
                                    price = disObj[k].vip_price;
                                    break;
                                }
                            }
                            disData.push({
                                vip_id: item.vip_id,
                                vip_name: item.vip_name,
                                vip_price: price
                            });
                        });
                        this.discountData = disData;
                    }
                }
            }

            //同步discountData数据
            ,syncDiscountData: function () {
                if(!obj.isEmpty(this.discountData) && this.discount.discount_type == 2){
                    let data = [];
                    this.discountData.forEach(function (item) {
                        data.push({
                            vip_id: item.vip_id,
                            vip_price: item.vip_price
                        });
                    });

                    this.discount.discount_data = JSON.stringify(data);
                } else {
                    this.discount.discount_data = "";
                }
            }
        },
        watch: {
            "discount.discount_type": function (newData) {
                let data = Object.assign(this.discount, {
                    discount_type: newData
                });
                this.$emit("change", data);
            },
            "discount.discount_data": function (newData) {
                let data = Object.assign(this.discount, {
                    discount_data: newData
                });
                this.$emit("change", data);

                this.initDiscount();
            },
            "discountData": function () {
                this.syncDiscountData();
            },
            "vipData": function (val) {
                if(!obj.isEmpty(val)){
                    let disData = [];
                    val.forEach((item) => {
                        //检查是否已经有数据
                        let price = "";
                        for (let k in this.discountData){
                            if(this.discountData[k].vip_id == item.vip_id){
                                price = this.discountData[k].vip_price;
                                break;
                            }
                        }

                        disData.push({
                            vip_id: item.vip_id,
                            vip_name: item.vip_name,
                            vip_price: price
                        });
                    });
                    this.discountData = disData;
                }
            }
        }
    }
</script>

<style scoped>
    .set-box{
        margin-top: 10px;
    }
    .set-line{
        margin-bottom: 10px;
    }
    .set-line:last-child{
        margin-bottom: 0px;
    }
</style>